export const formatPercentages = (percent: number) =>
	new Intl.NumberFormat("en-US", {
		//
		style: "percent",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	}).format(Math.abs(percent / 100));
